import client from './client';

export default (function ResultService() {
  let service;

  if (!service) {
    service = client.service('results');
  }

  return service;
}());
